import { Icon } from "../../../components/Icon/Icon.tsx";

export const CreditsAmountText = ({
  creditsAmount,
}: {
  creditsAmount: number;
}) => (
  <div className="flex-row gap-050">
    <div>{creditsAmount}</div>
    <Icon size="sm" name="Coins" />
  </div>
);
